import React from 'react';
import { get } from 'lodash-es';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { CmsModel } from 'client/data/models/cms';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { getModelState } from 'client/data/luckdragon/model';
import { handle404Error } from 'site-modules/shared/utils/errors';
import { parseContent } from 'client/data/cms/content';
import { getBreadcrumbSchema } from 'client/seo/schemas/breadcrumbs';
import { getMeta } from 'site-modules/shared/utils/seo-helper';
import { getTypeBeforeBuyContentPath } from 'site-modules/editorial/utils/content-path';
import { getTypeBeforeBuyBreadcrumbs } from 'site-modules/editorial/utils/breadcrumbs';
import {
  MOST_RESEARCHED_VEHICLES_CONTENT_PATH,
  NEW_CAR_RESOURCES_CONTENT_PATH,
} from 'client/data/constants/contents-paths';
import { TypeBeforeBuy } from './type-before-buy';

export const pageOptions = {
  name: 'car_reviews_buying_guides_what_you_should_know',
  category: 'car_reviews',
  preload: (store, props) => {
    const { type } = props.match.params;
    const preloader = new ModelPreloader(store);

    const contentPath = getTypeBeforeBuyContentPath(type);

    preloader.resolve(`content["${contentPath}.withContent"]`, CmsModel);
    preloader.resolve(`content["${NEW_CAR_RESOURCES_CONTENT_PATH}"]`, CmsModel);
    preloader.resolve(`content["${MOST_RESEARCHED_VEHICLES_CONTENT_PATH}"]`, CmsModel);

    return preloader.load().then(modelState => {
      const content = modelState.get(`content["${contentPath}.withContent"]`, CmsModel);

      if (!get(content, 'title')) {
        throw handle404Error({ errorMessage: `No before-buy content for ${type}` });
      }

      return preloader.load();
    });
  },
  seo: (state, props) => {
    const { type } = props.match.params;
    const modelState = getModelState(state);
    const content = parseContent(
      modelState.get(`content["${getTypeBeforeBuyContentPath(type)}.withContent"]`, CmsModel)
    );

    return {
      ...getMeta(content),
      jsonld: [getBreadcrumbSchema(getTypeBeforeBuyBreadcrumbs({ title: content.title, type }))],
    };
  },
  component: props => <TypeBeforeBuy type={get(props, 'match.params.type')} />,
};

export default pageDefinition(pageOptions);
